// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2ea4r","obliqueLineWrap":"membershipbadge_obliqueLineWrap__6wAmg","obliqueLine":"membershipbadge_obliqueLine__2xMui"};